
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    url: String,
    width: String,
    height: String,
  },
});
